module.exports = __webpack_public_path__ + "static/media/cleverchords_2.7d8a8cd0.jpg";